import React from 'react';
import { Navigate, useOutletContext } from 'react-router-dom';

import { Segments } from './Segments';

export const ARCHIVED_ROUTE = {
  key: 'Archived',
  name: 'Archived Documents',
  path: 'archived',
};

export const LIVE_ROUTE = {
  key: 'Linked',
  name: 'Linked to Segments',
  path: 'linked',
};

type WithContextProps = {
  children: ({ contentId }: { contentId: string }) => JSX.Element;
};
const WithContext = ({ children }: WithContextProps) => {
  const { contentId } = useOutletContext<{ contentId: string }>();
  return children({ contentId });
};

export const contentSegmentsRoutes = [
  { path: '', element: <Navigate to={LIVE_ROUTE.path} replace /> },
  {
    path: LIVE_ROUTE.path,
    element: <WithContext>{({ contentId }) => <Segments contentId={contentId} />}</WithContext>,
  },
  {
    path: ARCHIVED_ROUTE.path,
    element: (
      <WithContext>{({ contentId }) => <Segments contentId={contentId} isArchived />}</WithContext>
    ),
  },
];
